var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCdFVertValiderBat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39.1 24",
    style: {
      enableBackground: "new 0 0 39.1 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5,7.2L5.1,17.6l-4.8-4.8l1.2-1.2l3.5,3.5L14.3,6L15.5,7.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8,17.8V7.1h1.6c0.6,0,1.1,0,1.7,0.2c0.4,0.1,0.8,0.3,1.1,0.6c0.3,0.3,0.6,0.6,0.7,1c0.2,0.4,0.3,0.8,0.3,1.2 c0,0.8-0.3,1.5-0.9,2c0.5,0.2,1,0.5,1.4,1c0.3,0.5,0.5,1.1,0.5,1.7c0,0.8-0.3,1.6-0.9,2.1c-0.3,0.3-0.7,0.6-1.2,0.7 c-0.6,0.1-1.2,0.2-1.8,0.2L16.8,17.8z M18.4,11.7h0.5c0.5,0,0.9-0.1,1.3-0.4c0.3-0.3,0.5-0.7,0.4-1.2c0-0.4-0.1-0.8-0.4-1.1 c-0.3-0.3-0.8-0.4-1.2-0.4h-0.6V11.7z M18.4,16.3h1c0.6,0,1.1-0.1,1.6-0.4c0.6-0.6,0.7-1.6,0.1-2.2c0,0-0.1-0.1-0.1-0.1 c-0.5-0.4-1.2-0.5-1.8-0.5h-0.8L18.4,16.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,11.1h1.6v6.7h-1.6v-0.7c-1.2,1.2-3.1,1.2-4.2,0.1c-0.1,0-0.1-0.1-0.1-0.2c-0.6-0.7-0.9-1.6-0.9-2.6 c0-0.9,0.3-1.8,0.9-2.5c0.6-0.7,1.4-1,2.3-1c0.8,0,1.6,0.4,2.1,1V11.1z M25.9,7.7L27.4,7l1.9,2.5L28.4,10L25.9,7.7z M26.1,14.4 c0,0.6,0.2,1.1,0.5,1.6c0.3,0.4,0.8,0.6,1.4,0.6c0.5,0,1-0.2,1.4-0.6c0.4-0.4,0.6-1,0.5-1.6c0-0.6-0.2-1.1-0.5-1.6 c-0.4-0.4-0.9-0.6-1.4-0.6c-0.5,0-1,0.2-1.3,0.6C26.3,13.3,26.1,13.9,26.1,14.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4,8.8h-2.7V7.2h7.1v1.6h-2.7v9h-1.7V8.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdFVertValiderBat);
export default __webpack_public_path__ + "static/media/CdF_vert_valider-bat.a29741e8.svg";
export { ForwardRef as ReactComponent };